// removed by extract-text-webpack-plugin
module.exports = {"form":"_1XwaWvxpVtJBfY0erbPvrW","row":"_1F_GsAiZOdNeWtEdxA9umu","title":"_3oCiXGEDU2-DM1CWuTp12C","inputColumns":"_3HpfW97DyKn6KXFoEMAp1x","inputColumn":"_2SOs0p9yiEtjDaCZcjTFis","bigTitle":"_1BuzDwdlky9XAnB9xFvGkx","bigButton":"_3fy8p1FqZeCYVhHFzOCFWn","submitButton":"olwiwCj2bvJN7xSvkp0aj","removeButton":"_3x0BY9c5ZVIucrGVCPjQyI"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/form/Form.css
 ** module id = 719
 ** module chunks = 0 1
 **/